import { WorkTitle } from "../../orders/orderAPI";
import { Chip } from "@mui/material";

type ChipsProps = {
  workTitles: WorkTitle[];
  onDelete?: (workTitleId: string) => void;
};

const Chips = ({ workTitles, onDelete }: ChipsProps) => {
  return (
    <>
      {workTitles.map((workTitle) => {
        // Use workTitle.name if available, otherwise fallback to workTitle.id
        const chipLabel = workTitle.name ?? `ID: ${workTitle.id}`;
        return (
          <Chip
            key={workTitle.id} // Simplified key as ID should be unique
            label={chipLabel}
            onDelete={onDelete && (() => onDelete(workTitle.id))}
            sx={{
              marginRight: 1,
              backgroundColor: "#A273E1",
              color: "#FFFFFF",
              fontWeight: 600,
              fontSize: 14,
              height: 24,
              "& .MuiChip-deleteIcon": {
                color: "#FFFFFF70",
              },
              "& .MuiSvgIcon-root": {
                width: "0.8em",
                height: "0.8em",
              },
            }}
            variant="filled"
          />
        );
      })}
    </>
  );
};

export default Chips;
